module.exports = __webpack_public_path__ + "img/icon-account-deactivate-green@3x.a78040af.png";